const transportation = [
    {
        id : 'A001',
        car_type : 'Avanza',
        car_code : 'AVZ',
        pax : 1,
        price : "Rp 350.000",
    },
    {
        id : 'A002',
        car_type : 'Avanza',
        car_code : 'AVZ',
        pax : 2,
        price : "Rp 550.000",
    },
    {
        id : 'H001',
        car_type : 'Hiace',
        car_code : 'HIC',
        pax : 5,
        price : "Rp 1.000.000",
    },
    {
        id : 'H002',
        car_type : 'Hiace',
        car_code : 'HIC',
        pax : 6,
        price : "Rp 1.200.000",
    },
]

export default transportation